<script setup lang="ts">
defineOptions({
	name: 'ChangesSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-ic:outline-cookie"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Changes to the Policy') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						`Gaveta Decimal reserves the right to change this Policy at any time. In the event of a change to the Policy, the “Last Updated Date,” available at the end of this page, will also be updated. If the change is substantial, a notice will be placed on the Platform`,
					)
				}}.
			</p>

			<p>
				{{
					$t(
						`Continuing to use the Platform after the “Last Updated Date” will signify Users’ acceptance of and consent to these alterations`,
					)
				}}.
			</p>
		</div>
	</section>
</template>
